<template>
	<main id="home" class="single page main">
		<HomeBanner />
		<ModuleBuilder />
	</main>
</template>


<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import HomeBanner from '@/components/parts/HomeBanner'

export default {
	name: 'home-page',
	components:{
		ModuleBuilder,
		HomeBanner,
	},
}
</script>